<script>
import router from '../../router/'
import jwt_decode from "jwt-decode"
function toDetail(flag, id){
      let routeUrl= ""
      if(flag === 1){
        routeUrl = router.resolve({
          path: "/booksDetail?" + id
        });
      }
      else{
        routeUrl = router.resolve({
          path: "/courseDetail?" + id
        });
      }
      window.open(routeUrl.href, '_blank')
}

function toPage(path){
  window.location.href = 'http://' + window.location.host + path;
}

function imgJcError(e){
   // e.srcElement.src = require("@/assets/img/jc_noimg.jpg");
    e.srcElement.onerror=null;
}
function imgCourseError(e){
    //e.srcElement.src = require("@/assets/img/course_noimg.jpg");
    e.srcElement.onerror=null;
}
export default {
    toDetail,
    toPage,
    imgJcError,
    imgCourseError
};
</script>
